var util = require('./util');
var extend = util.extend;
var baseAjax = util.ajax;
var convertBase64UrlToFile = util.convertBase64UrlToFile;
var $ = require('jQuery');
var ajax = function (obj, success, error) {
  var begin = new Date().getTime();
  console.log(obj.url, 'url')
  baseAjax({
    url: obj.url,
    query: obj.getparams,
    type: obj.method,
    data: obj.postparams,
    dataType: obj.datatype,
    timeout: obj.timeout,
    contentType: obj.contentType,
    encrypt: obj.encrypt !== false,
    success: function (res) {
      success(res);
    },
    error: function (xhr, status, err) {
      error(err);
    },
    complete: function () {
      var end = new Date().getTime();
      var delta = end - begin;
      console.info('[接口耗时]', delta / 1000, obj.url);
    }
  });
};

var Image = function (options) {
  this._api = '';
  this._cdn = '';
};

Image.prototype = {
  init: function (options) {
    var defaults = {
      api: 'https://upload.58cdn.com.cn/json',
      cdn: 'http://pic3.58cdn.com.cn'
    };
    extend(defaults, options);
    this._api = defaults.api;
    this._cdn = defaults.cdn;
  },

  upload: function (imagedata, success, fail) {
    var self = this;
    var path = '/nowater/webim/big/';
    var method = 'POST'
    var postParams = {
      'Pic-Size': '0*0',
      'Pic-Encoding': 'base64',
      'Pic-Path': path,
      'Pic-Data': imagedata.msg_url
    };
    var contentType = 'text/plain;charset=UTF-8';
    if (imagedata.upload_url && imagedata.upload_url.url) {
      self._api = imagedata.upload_url.url;
      self._cdn = 'https://pic1.58cdn.com.cn';
      console.log(self._api, 'url=====')
      // 转换成二进制流文件
      postParams = convertBase64UrlToFile(imagedata.msg_url, imagedata.upload_url.file_name);
      console.log(postParams)
      contentType = 'image/' + imagedata.upload_url.file_suffix;
      method = 'PUT';
    } else if (imagedata.msg_url.indexOf(',') !== -1) {
      imagedata.msg_url = imagedata.msg_url.split(',')[1];
    }
    ajax({
      method: method,
      url: self._api,
      postparams: postParams,
      encrypt: false,
      contentType: contentType
    }, function (res) {
      if (res && typeof res === 'string') {
        success(self._cdn + path + res);
      } else if (imagedata && imagedata.upload_url && imagedata.upload_url.file_name && res.eTag) {
        var reg = /^http(s)?:\/\/(.*?)\//
        var imgUrl = imagedata.upload_url.url.split('?')[0].replace(reg, 'https://pic1.58cdn.com.cn/');
        success(imgUrl);
      } else {
        fail('');
      }
    }, function (err) {
      fail(err);
    });
  }
};

module.exports = new Image();
